// extracted by mini-css-extract-plugin
export default {"highlight":"Highlight_highlight__1t0Zq"};